<script setup lang="ts">
definePage({
  path: '/auth/redirect',
  name: 'auth.redirect',
  meta: {
    layout: 'empty',
    isAuthRedirect: true,
    allowAnonymous: true,
  },
})
</script>

<template>
  <div />
</template>